<app-modal-layout>
	<div header>
		<span>{{ title }}</span>
	</div>

	<div body>
		Your session will expire automatically in 5 min.<br />
		Select 'Continue session' to extend your session.
	</div>

	<div footer>
		<app-button [isSecondary]="true" (click)="endSession()">End session now</app-button>
		<app-button [isPrimary]="true" (click)="continueSession()">Continue session</app-button>
	</div>
</app-modal-layout>
